import { render, staticRenderFns } from "./ExtradataTable.vue?vue&type=template&id=a16b1690&scoped=true"
import script from "./ExtradataTable.vue?vue&type=script&lang=ts"
export * from "./ExtradataTable.vue?vue&type=script&lang=ts"
import style0 from "./ExtradataTable.vue?vue&type=style&index=0&id=a16b1690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16b1690",
  null
  
)

export default component.exports